const educations = {
    academia:{
        title: 'Academia',
        data:{
            unb:{
                curso: 'Engenharia de Software',
                college: 'Universidade de Brasília - UnB',
                duration: '2017 - Atualmente'
            }
        }
    },
    idioma:{
        title: 'Idiomas',
        data:{
            english:{
                curso: 'Inglês - Básico',
                college: 'CIL do Gama',
                duration: '2015 - 2017'
            },
            spanish:{
                curso: 'Espanhol - Básico',
                college: 'CIL do Gama',
                duration: '2015 - 2017'
            }
        }
    },
    cursos:{
        title: 'Cursos',
        data:{
            alura:{
                curso: 'Grupo Caelum - Alura',
                college: 'Cursos diversos',
                certificado: 'https://cursos.alura.com.br/user/esio-gustavo/fullCertificate/bda262a61e66cd552fb0d36822bdbd0e'
            }
        }
    }
}

export default educations;